/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import moment from 'moment';
import { message } from 'antd';
import get from 'lodash/get';
import { Header, Title } from '$app/shared/components/Header';
import { Container } from '$app/shared/components/Container';
import makeCampaignForm from '../../components/CampaignCreateForm';
import { createCampaign } from './actions';

const CampaignForm = makeCampaignForm();
const dateTimeFormat = 'YYYY-MM-DD HH:mm';

const CampaignCreatePage = ({ history }) => {
  const sitewideRef = useRef({ sitewide: false, inclusive: true, expectedRev: 0 });

  const handleSubmit = (e, form) => {
    form.validateFieldsAndScroll((err, values) => {
      const {
        discountAmountPence,
        discountAmountPercentage,
        validFromDate,
        validUntilDate,
        singleUse,
      } = values;
      const newValues = {
        ...values,
        singleUse: singleUse || false,
        discountAmountPence: discountAmountPence * 100 || undefined,
        discountAmountPercentage: discountAmountPercentage / 100 || undefined,
        validFromDate: moment(validFromDate).format(dateTimeFormat),
        validUntilDate: moment(validUntilDate).format(dateTimeFormat),
      };

      delete newValues.couponOrDiscount;
      if (sitewideRef.current.sitewide) {
        Object.assign(newValues, sitewideRef.current);
      }

      if (!err) {
        createCampaign(newValues)
          .then((data) => {
            message.info('Campaign created', 3);
            return history.push(`/${data.campaignId}`);
          })
          .catch((error) =>
            message.error(get(error, 'response.data.message') || 'Could not create campaign', 3)
          );
      }
    });
  };

  return (
    <Container className="CampaignCreatePage">
      <Header className="justify">
        <Link to="/">Back</Link>
        <Title>Create Campaign</Title>
      </Header>
      <CampaignForm onSubmit={handleSubmit} onSitewideState={(next) => { sitewideRef.current = next; }} />
    </Container>
  );
};

export default withRouter(CampaignCreatePage);
